import React from "react"

type ErrorMessageProps = {
    text: string | null | undefined;
}

export function ErrorMessage({text}: ErrorMessageProps) {

    if(!text) return null

    return (
        <div className="flex items-center justify-center text-red">
            {text}
        </div>
    )
}